module.exports = __webpack_public_path__ + "static/media/social-dribbble.0c731451.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-dribbble.svg
// module id = 154
// module chunks = 0